import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
interface Testimonial {
  text: string;
  name: string;
  location: string;
}
const TESTIMONIALS: Testimonial[] = [{
  text: 'Pensé que nunca más iba a volver a comer pan. Me sorprendió muchísimo la variedad.',
  name: 'Marta G.',
  location: 'Córdoba'
}, {
  text: 'Las recetas son fáciles y los ingredientes se consiguen en cualquier lado.',
  name: 'Jorge P.',
  location: 'Rosario'
}, {
  text: 'Por fin encontré opciones que realmente me gustan.',
  name: 'Lucía R.',
  location: 'La Plata'
}, {
  text: 'Lo uso todas las semanas. Cambió mi forma de cocinar.',
  name: 'Daniel S.',
  location: 'Mendoza'
}];
function initials(name: string) {
  return name.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
}
export function Testimonials() {
  return <section className="py-16 md:py-24 px-5 bg-white" data-id="element-190">
      <div className="max-w-4xl mx-auto" data-id="element-191">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-192">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900" data-id="element-193">
            Lo que dicen quienes ya la están usando
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5" data-id="element-194">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="relative bg-gray-50 rounded-2xl p-6 border border-gray-100" data-id="element-195">
              <Quote className="absolute top-5 right-5 w-7 h-7 text-primary/10" data-id="element-196" />

              <div className="flex text-accent mb-3" data-id="element-197">
                {[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 fill-current" data-id="element-198" />)}
              </div>

              <p className="text-gray-700 leading-relaxed mb-5" data-id="element-199">“{t.text}”</p>

              <div className="flex items-center gap-3" data-id="element-200">
                <div className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center font-bold text-sm flex-shrink-0" data-id="element-201">
                  {initials(t.name)}
                </div>
                <div data-id="element-202">
                  <p className="text-sm font-semibold text-gray-900 leading-tight" data-id="element-203">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-500 leading-tight" data-id="element-204">
                    {t.location}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}